import { Injectable, inject } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { SectionsFacade } from '@web/store/page-structure/sections/sections.facade';
import { switchMap } from 'rxjs/operators';

import ColumnsAction from '../columns/columns.actions';
import SectionsActions from './sections.actions';

@Injectable()
export class SectionsEffects {
    private readonly actions$ = inject(Actions);
    private sectionsFacade = inject(SectionsFacade);

    // public readonly addSection$ = createEffect(() =>
    //     this.actions$.pipe(
    //         ofType(SectionsActions.addSection),
    //         switchMap(({ section, index }) => {
    //             const newSectionInstance = this.sectionsFacade.getSectionInstanceValue(section.blockId);
    //             const sectionId = newSectionInstance.id;
    //             return [
    //                 // SectionsActions.addManySections({ sections: section }),
    //                 ColumnsAction.addManyColumns({ columns: section.columns, sectionId: section.id }),
    //             ];
    //         }),
    //     ),
    // );

    public readonly createSection$ = createEffect(() =>
        this.actions$.pipe(
            ofType(SectionsActions.createSection),
            switchMap(({ blockId, index, widgetCorrelationData, skipHistory }) => {
                const newSectionInstance = this.sectionsFacade.getSectionInstanceValue(blockId);
                const sectionId = newSectionInstance.id;
                return [
                    SectionsActions.sectionCreated({ section: newSectionInstance, index, skipHistory }),
                    ColumnsAction.createColumn({ index: 0, sectionId, widgetCorrelationData, skipHistory: true }),
                ];
            })
        )
    );

    /**
     * A zero row carries no layout knobs of its own, but it still needs the
     * subtype: the migration can only infer it from the parent block, which does
     * not happen until the page is reloaded.
     */
    public readonly createZeroSection$ = createEffect(() =>
        this.actions$.pipe(
            ofType(SectionsActions.createZeroSection),
            switchMap(({ blockId, index, skipHistory }) => {
                const newSectionInstance = this.sectionsFacade.getZeroSectionInstanceValue(blockId);
                const sectionId = newSectionInstance.id;
                return [
                    SectionsActions.sectionCreated({ section: newSectionInstance, index, skipHistory }),
                    ColumnsAction.createColumn({ index: 0, sectionId, skipHistory: true }),
                ];
            })
        )
    );

    public readonly createSpecificSection$ = createEffect(() =>
        this.actions$.pipe(
            ofType(SectionsActions.createSpecificSection),
            switchMap(({ blockId, index, skipHistory }) => {
                const newSectionInstance = this.sectionsFacade.getSpecificSectionInstanceValue(blockId);
                const sectionId = newSectionInstance.id;
                return [
                    SectionsActions.sectionCreated({ section: newSectionInstance, index, skipHistory }),
                    ColumnsAction.createSpecificColumn({ index: 0, sectionId, skipHistory: true }),
                ];
            })
        )
    );
}
